import styled from "@emotion/styled";
import { MDSText } from "@/mds/components/text";
import { MDSTextField } from "@/mds/components/forms/text-field/text-field";

export const StyledFindBarContainer = styled.div`
  position: absolute;
  top: ${({ theme }) => theme.spacing[4]};
  right: ${({ theme }) => theme.spacing[4]};
  z-index: ${({ theme }) => theme.zIndex.FloatingBar};
  display: flex;
  align-items: center;
  height: 48px;
  width: 336px;
  max-width: 90vw;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.surface.modal};
  border: 1px solid ${({ theme }) => theme.colors.border.surface};
  border-radius: ${({ theme }) => theme.borderRadius.large};
  box-shadow: ${({ theme }) => theme.shadows.surface};
  padding: ${({ theme }) => theme.spacing[1]};
`;

export const StyledFindBarExpanding = styled.div`
  flex: 1;
  min-width: 0;
  overflow: hidden;
`;

export const StyledFindBarInput = styled(MDSTextField)``;

export const StyledMatchCounterText = styled(MDSText)`
  margin: auto 0 auto ${({ theme }) => theme.spacing[1]};
  white-space: nowrap;
`;
